import React, { useEffect } from "react";
import Accordion from "react-bootstrap/Accordion";
import { useDispatch, useSelector } from "react-redux";
import { fetchAdminCategories } from "../../../../utils/redux/category/categoryActions";
import CategoryCard from "../../../Reusables/CategoryCard/CategoryCard";
import { fetchAllFilters } from "../../../../utils/redux/filter/filterActions";

const CategoryListingPage = () => {
    const dispatch = useDispatch();

    // Fetch categories from redux
    const { categories, loading, error } = useSelector((state) => state.category);

    useEffect(() => {
        // Fetch categories on mount
        dispatch(fetchAdminCategories());
        dispatch(fetchAllFilters());
    }, [dispatch]);

    return (
        <div className="d-flex flex-column align-items-center">
            <div className="d-flex my-4 w-100 justify-content-between">
                <h3>Product Categories</h3>
            </div>

            {/* Loading / Error states */}
            {loading && <div className="text-primary mb-3">Loading categories...</div>}
            {error && <div className="text-danger mb-3">{error}</div>}

            <Accordion className="w-100">
                {categories && categories?.length ? (
                    categories?.map((category, index) => (
                        <CategoryCard key={category._id} index={index} category={category} />
                    ))
                ) : !loading && (
                    <div className="text-muted">No categories found</div>
                )}
            </Accordion>
        </div>
    );
};

export default CategoryListingPage;
